package org.gstechnovos.jexonplastech.sections.product_details.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.gstechnovos.jexonplastech.sections.products.model.GlobalCatalog
import org.gstechnovos.jexonplastech.sections.products.sections.ProductCard
import org.gstechnovos.jexonplastech.sections.products.sections.defaultProductsGridData
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.gstechnovos.jexonplastech.util.animateSlideUp
import org.gstechnovos.jexonplastech.util.rememberScrollVisibility
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

/**
 * ==========================================
 * IMAGE REQUIREMENTS: RELATED PRODUCTS (GRID CARDS)
 * ==========================================
 * - Universal Aspect Ratio: 1:1 (Square).
 * - Recommended Dimensions: 800 x 800 pixels (Minimum 600 x 600 pixels).
 * - Composition: Product centered with ~10-20% empty margin to prevent clipping during hover zoom animations.
 * - Background/Format: Transparent or Pure White (#FFFFFF) in WebP or PNG format.
 * - Rendering Behavior: Renders via the shared ProductCard component inside a 250px fixed-height container using ObjectFit.Contain[cite: 48].
 */
@Composable
fun RelatedProductsSection(currentCategory: String, currentModelToExclude: String) {
    val palette = ColorMode.current.toSitePalette()
    val (isVisible, visibilityRef) = rememberScrollVisibility(threshold = 0.1)

    val relatedProducts = GlobalCatalog.items
        .filter { it.category == currentCategory && it.modelNumber != currentModelToExclude }
        .take(4)

    if (relatedProducts.isNotEmpty()) {
        Div(
            attrs = Modifier
                .fillMaxWidth()
                .display(DisplayStyle.Flex)
                .flexDirection(FlexDirection.Column)
                .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
                .toAttrs {
                    ref { element ->
                        visibilityRef(element)
                        onDispose {}
                    }
                }
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(leftRight = 5.percent, topBottom = 60.px)
                    .backgroundColor(palette.custom.lightGray.toRgb().copyf(alpha = 0.2f)),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .maxWidth(1200.px)
                        .animateSlideUp(isVisible, delayMs = 150)
                ) {
                    SpanText(
                        text = "Related Products",
                        modifier = Modifier
                            .fontSize(24.px)
                            .fontWeight(FontWeight.Bold)
                            .color(palette.custom.darkText)
                            .margin(bottom = 24.px, top = 40.px)
                    )

                    SimpleGrid(
                        numColumns(1, sm = 2, md = 3, xl = 4),
                        modifier = Modifier.fillMaxWidth().gap(30.px).margin(bottom = 40.px)
                    ) {
                        relatedProducts.forEach { product ->
                            ProductCard(product)
                        }
                    }
                }
            }
        }
    }
}